export default __webpack_public_path__ + "static/media/Logo Respinos 3.14fcc1eb.png";